<div class="container" [formGroup]="form">
    <ng2-flatpickr formControlName="date" [config]="options"></ng2-flatpickr>
    <ng-content></ng-content>
</div>